import { render } from "./digitalChatSetting.vue?vue&type=template&id=388d4784&scoped=true&ts=true"
import script from "./digitalChatSetting.vue?vue&type=script&lang=ts"
export * from "./digitalChatSetting.vue?vue&type=script&lang=ts"

import "./digitalChatSetting.vue?vue&type=style&index=0&id=388d4784&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388d4784"]])

export default __exports__